const options = {
  5: "bg-cyan-600/5",
  10: "bg-cyan-600/10",
  25: "bg-cyan-600/25",
  50: "bg-cyan-600/50",
  75: "bg-cyan-600/75",
  90: "bg-cyan-600/90",
  100: "bg-cyan-600",
};

const from = {
  5: "from-cyan-600/5",
  10: "from-cyan-600/10",
  25: "from-cyan-600/25",
  50: "from-cyan-600/50",
  75: "from-cyan-600/75",
  90: "from-cyan-600/90",
  100: "from-cyan-600",
};

export default function getBackgroundCyan600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
